import React, { useState, useEffect, useRef, useCallback } from "react";
import CustomButton from "./CustomButton";
import EditIcon from "../assets/EditIcon.png";
import MenuScreen from "./MenuScreen";
import ModalScreen from "./ModalScreen";
import MyProfile from "./MyProfile";
import DeleteProfile from "./DeleteProfile";
import UpdateProfile from "./UpdateProfile";
// import { fetchContent } from "../services/api";
import AddProfile from "./AddProfile";
import selectedIcon from "../assets/selectedIcon.png";
import { Translate } from "./LanguageChanger";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import logoutIcon from "../assets/Logout-Icon.png";
import backIcon from "../assets/back-button.png";
import Wrapper from "./shared/Wrapper";
import { getUserProfile } from "../services/services";
import AuthFailModal from "./AuthFailModal";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";

const EditProfile = ({ navigate, isLogedIn }) => {
  const [selectedElementIndex, setSelectedElementIndex] = useState(0);
  const [confirmedSelection, setConfirmedSelection] = useState(null);
  const [state, setState] = useState({
    isEditSelected: false,
    isDeleteSelected: false,
    shouldCloseMenu: true,
    shouldShowModal: false,
    isBackButtonSelected: false,
    errTitle: "",
    errDescription: "",
    errIcon: "",
    button: ["Logout", "Cancel"],
    iconWdth: "",
    iconHeight: "",
    shouldShowAuthModal:false
  });
  const {
    isEditSelected,
    isDeleteSelected,
    shouldCloseMenu,
    shouldShowModal,
    errTitle,
    errDescription,
    errIcon,
    button,
    iconWdth,
    iconHeight,
    isBackButtonSelected,
    shouldShowAuthModal,
  } = state;

  const [screen, setScreen] = useState();
  const [data, setData] = useState({});

  // const navigateToScreen = (screen, data = {}) => {
  //   setScreen(screen);
  //   setData(data);
  // };

  const navigateToScreen = (screen, data = {}) => {
    setScreen(screen);
    setData(data);
    window.removeEventListener("keydown", EditProfileKeyHandler);
    // window.addEventListener("keydown", EditProfileKeyHandler);
  };

  // let user_details = localStorage.getItem("user_details");
  // const user_profile = JSON.parse(user_details);

  let user_details = JSON.parse(localStorage.getItem("user_details")).user_profiles;
  // const user_profile = JSON.parse(user_details);
  
  // const updatedMyprofile = JSON.parse(localStorage.getItem("updateMyProfile")).data;

  // const user_profile = updatedMyprofile ? updatedMyprofile : user_details;

  const updatedMyprofile = localStorage.getItem("updateMyProfile")
  ? JSON.parse(localStorage.getItem("updateMyProfile")).data
  : null;

  // const user_profile = updatedMyprofile ? updatedMyprofile.data : user_details.user_profiles;

  const user_profile = updatedMyprofile ? updatedMyprofile : user_details;

  // --- Optimization: Profiles Calculation (Lazy Init) ---
  const [profiles, setProfiles] = useState(() => {
    try {
      const user_details = JSON.parse(localStorage.getItem("user_details"))?.user_profiles;
      const updatedMyprofile = localStorage.getItem("updateMyProfile")
        ? JSON.parse(localStorage.getItem("updateMyProfile")).data
        : null;
      const user_profile = updatedMyprofile ? updatedMyprofile : user_details;
      
      return user_profile?.map((profile) => ({
        name: profile.username,
        image: profile.profile,
        isKids: profile.is_kid,
        profileId: profile.profile_id,
      })) || [];
    } catch (e) {
      return [];
    }
  });

  const profileRefs = useRef([]);
  // Refs safety check
  if (profileRefs.current.length !== profiles.length) {
    profileRefs.current = profiles.map((_, i) => profileRefs.current[i] ?? React.createRef());
  }

  const addProfileRef = useRef(null);
  const editButtonRef = useRef(null);
  const deleteButtonRef = useRef(null);
  // --- 1. API Call & Matomo (Runs Only ONCE) ---
  useEffect(() => {

    // API Call
    const loadDataOnlyOnce = async () => {
        const userId = localStorage.getItem("profileId");
        // Token check to avoid 401 error spam
        const token = localStorage.getItem("JWTToken");
        
        if (!userId || !token) {
            console.warn("Missing Token or UserID, skipping API call");
            return;
        }

        try {
            const response = await getUserProfile(userId);

            if (!response.success && response.status === null) {
                console.log("Auth Failed");
                handleAuthFailLogout();
                return;
            }

            if (response.statusCode === 200) {
                localStorage.setItem("updateMyProfile", JSON.stringify(response));
                MenuScreen.ReseTfocus(-1);
                setState((prevState) => ({
                    ...prevState,
                    updateData: response.data,
                    shouldShowModal: false
                }));
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    loadDataOnlyOnce();

  }, []); // Empty Array = NO LOOP

  const handleMenuselection = (selectedMenu) => {
    switch (selectedMenu) {
      case "Login":
        navigate("LoginScreen");
        break;
      case "Profile":
        navigate("ProfileScreen");
        break;
      case "Search":
        navigate("SearchScreen");
        break;
      case "Live":
        navigate("LiveScreen");
        break;
      case "Home":
        navigate("HomePage");
        break;
      case "Watchlist":
        break;
      case "Categories":
        navigate("CategoryScreen");
        break;
      case "Settings":
        navigate("SettingsScreen");
        break;
      case "Logout":
        break;
      default:
        break;
    }
  };

  const handleRightButton = () => {
    // First, update the state
    // setSelectedElementIndex(0);
    // document.getElementById("profile_0").focus();
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
    }));

    // Then perform DOM operations and other actions outside the state update
    MenuScreen.SetFocus(true);

    // Uncomment if you want to navigate to the CategoryScreen
    // navigate("CategoryScreen");
  };

  const modalOKButtonHandler = (action) => {

    

    if(window.tizen) {
      sendTestMatomoEvent({ eventAction: `App`, eventName: `End`, url:"profile" });
      window.tizen.application.getCurrentApplication().exit();
    }
    else {
      sendTestMatomoEvent({ eventAction: `App`, eventName: `End`, url:"profile" });
      window.close();
    }
    // switch (action) {
    //   case "Login":
    //     navigate("LoginScreen");
    //     break;
    //   case "Logout":
    //     localStorage.removeItem("JWTToken");
    //     localStorage.removeItem("userInfo");
    //     let headers = {
    //       iskid: "0",
    //       Langid: "1",
    //       "Content-Type": "application/json",
    //       country: "india",
    //     };
    //     Promise.all([fetchContent("/V1/logout", "POST", headers)]);
    //     MenuScreen.ReseTfocus(4);
    //     MenuScreen.SetFocus(true);
    //     handleMenuselection("Login");
    //     break;
    //   default:
    //     break;
    // }
  };
  const modalCANCELButtonHandler = () => {
    // MenuScreen.ReseTfocus(-1);
    setState((prevState) => ({
      ...prevState,
      shouldShowModal: false,
      // shouldFocusToRowList: true,
    }));
    MenuScreen.ReseTfocus(1);
    setSelectedElementIndex(0);
    MenuScreen.SetFocus(true);
    window.addEventListener("keydown", EditProfileKeyHandler);
  };

  const handleExit = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Exit",
      errDescription: "ExitMsg",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Yes", "No"],
    }));
    MenuScreen.SetFocus(true);
  }, []);

  const handleBackButton = useCallback(() => {
    window.removeEventListener("keydown", EditProfileKeyHandler);
    navigate("ProfileScreen");
  }, []);

  const handleLogout = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToGrid: false,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Logout",
      errDescription: "cofirm-logout",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Logout", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  }, []);

  const handleAuthFailLogout = useCallback(() => {
    console.log("handleAuthFailLogout......");
    // localStorage.removeItem("user_details");
    setState((prevState) => ({
      ...prevState,
      shouldFocusToGrid: false,
      shouldCloseMenu: true,
      shouldShowModal: false,
      shouldShowAuthModal: true,
      // errTitle: "Session-Expired",
      errDescription: "session-desc",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Login"],
    }));
    MenuScreen.SetFocus(true);
  }, []);

  const EditProfileKeyHandler = (event) => {
    if(shouldShowModal || shouldShowAuthModal) return;
    if (event.keyCode !== undefined) {
      switch (event.keyCode) {
        case 13: // Enter key
          if (isBackButtonSelected) {
            handleBackButton();
            return;
          }
          if (selectedElementIndex < profiles.length) {
            localStorage.setItem(
              "EditProfile",
              JSON.stringify(profiles[`${selectedElementIndex}`])
            );
            if (localStorage.getItem("EditProfile")) {
              navigate("UpdateProfile");
            }
          }
          break;
        case 39: // Right arrow
          if (selectedElementIndex < profiles.length - 1) {
            // console.log("selectedElementIndex", selectedElementIndex, profiles.length);
            if(profiles.length){
            setSelectedElementIndex((prevIndex) => prevIndex + 1);
            }else {
              console.log("profiles.length", profiles.length);
            }
          }
          break;
        case 37: // Left arrow
          if(selectedElementIndex===0){

       setState((prevState) => ({
              ...prevState,
              shouldShowFocus: false,
              shouldCloseMenu: false,
              shouldAddEventListener: false,
            }));
            
                        MenuScreen.SetFocus(false)
        }
          if (selectedElementIndex > 0) {
            setSelectedElementIndex((prevIndex) => prevIndex - 1);
          }
          break;
        case 38: // Up arrow
          if (!isBackButtonSelected) {
            setState((prevState) => ({
              ...prevState,
              isBackButtonSelected: true,
            }));
            setSelectedElementIndex(null);
          }
          if (selectedElementIndex === profiles.length + 1) {
            // addProfileRef.current.focus();
            setSelectedElementIndex(profiles.length);
            setState((prevState) => ({
              ...prevState,
              isEditSelected: false,
              isDeleteSelected: true,
            }));
            // setState({ isEditSelected: false, isDeleteSelected: false });
          } else if (selectedElementIndex === profiles.length + 2) {
            // editButtonRef.current.focus();
            setSelectedElementIndex(profiles.length + 1);
            setState((prevState) => ({
              ...prevState,
              isEditSelected: true,
              isDeleteSelected: false,
            }));
            // setState({ isEditSelected: true, isDeleteSelected: false });
          } else if (selectedElementIndex === profiles.length) {
            profileRefs.current[profiles.length - 1].current.focus();
            setSelectedElementIndex(profiles.length - 1);
          }

          break;
        case 40: // Down arrow
          if (isBackButtonSelected) {
            setState((prevState) => ({
              ...prevState,
              isBackButtonSelected: false,
            }));
            setSelectedElementIndex(0);
            return;
          }
          // if (selectedElementIndex < profiles.length) {
          //   // profileRefs.current[selectedElementIndex].current.blur();
          //   setSelectedElementIndex(profiles.length + 1);
          //   setState((prevState) => ({
          //     ...prevState,
          //     isEditSelected: true,
          //     isDeleteSelected: false,
          //   }));
          //   // setState({ isEditSelected: true, isDeleteSelected: false });
          // } else if (selectedElementIndex === profiles.length) {
          //   // addProfileRef.current.blur();
          //   setSelectedElementIndex(profiles.length + 1);
          //   setState((prevState) => ({
          //     ...prevState,
          //     isEditSelected: true,
          //     isDeleteSelected: false,
          //   }));
          //   // setState({ isEditSelected: true, isDeleteSelected: false });
          // } else if (selectedElementIndex === profiles.length + 1) {
          //   setState((prevState) => ({
          //     ...prevState,
          //     isEditSelected: false,
          //     isDeleteSelected: true,
          //   }));
          //   // setState({ isEditSelected: false, isDeleteSelected: true });
          //   setSelectedElementIndex(profiles.length + 2);
          // }
          break;
        case 461:
          handleBackButton(); // return key
          // callBack("Back");
          break;
        case 8:
          handleBackButton();
          break;
        case 10009:
          handleBackButton();
          break;
        default:
          break;
      }

      if (
        !isBackButtonSelected && 
        selectedElementIndex < profiles.length &&
        profileRefs.current[selectedElementIndex].current
      ) {
        profileRefs.current[selectedElementIndex].current.focus();
      } else if (
        selectedElementIndex === profiles.length &&
        addProfileRef.current
      ) {
        addProfileRef.current.focus();
      } else if (
        selectedElementIndex === profiles.length + 1 &&
        editButtonRef.current
      ) {
        editButtonRef.current.focus();
      } else if (
        selectedElementIndex === profiles.length + 2 &&
        deleteButtonRef.current
      ) {
        deleteButtonRef.current.focus();
      }
    }
  };

  // const moveToUpdate = () =>{
  //   localStorage.setItem(
  //     "EditProfile",
  //     JSON.stringify(profiles[`${selectedElementIndex}`])
  //   );
  //   if (localStorage.getItem("EditProfile")) {
  //     navigate("UpdateProfile");
  //   }
  // }

  const moveToUpdate = (index) => {
    if (profiles[index]) {
      localStorage.setItem("EditProfile", JSON.stringify(profiles[index]));
      navigate("UpdateProfile");
    } else {
      console.error("Profile not found for index:", index);
    }
  };

  const updateloadData = async () => {
    const userId = localStorage.getItem("profileId");
    const getCountry = localStorage.getItem("country");
    let myHeaders = {
      platform: "0",
      iskid: "0",
      age: "12",
      country: getCountry,
      Langid: "1",
      
      timestamp: "0000000000",
      // profileid: user_details["user_profiles"][0]["profile_id"],
      Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      "Content-Type": "application/json"
    };

    try {
      // const [response] = await Promise.all([
      //   fetchContent(
      //     `/V1/getUserProfile/lastupdated/0000000000/userId/${userId}`,
      //     "GET",
      //     myHeaders
      //   )
      // ]);

      const response = await getUserProfile(userId);

      if(!response.success && response.status === null){
        console.log("test updatedMyProfile...")
        handleAuthFailLogout()
      }


      if (response.statusCode === 200) {
        localStorage.setItem("updateMyProfile", JSON.stringify(response));
        MenuScreen.ReseTfocus(-1);
        setState((prevState) => ({
          ...prevState,
          updateData: response.data,
          shouldShowModal: false
        }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // --- 2. Event Listener & Focus Effect (Runs on Index Change) ---
  useEffect(() => {
    if(shouldShowModal || shouldShowAuthModal) return;
    
    // Focus Logic
    if (
        selectedElementIndex < profiles.length &&
        profileRefs.current[selectedElementIndex]?.current
    ) {
        profileRefs.current[selectedElementIndex].current.focus();
    } else if (
        selectedElementIndex === profiles.length &&
        addProfileRef.current
    ) {
        addProfileRef.current.focus();
    } else if (
        selectedElementIndex === profiles.length + 1 &&
        editButtonRef.current
    ) {
        editButtonRef.current.focus();
    } else if (
        selectedElementIndex === profiles.length + 2 &&
        deleteButtonRef.current
    ) {
        deleteButtonRef.current.focus();
    }

    // Listener
    const timeoutId = setTimeout(() => {
        window.removeEventListener("keydown", EditProfileKeyHandler);
         if(shouldCloseMenu) 
        window.addEventListener("keydown", EditProfileKeyHandler);
    }, 200);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("keydown", EditProfileKeyHandler);
    };
  }, [selectedElementIndex, shouldShowModal, shouldShowAuthModal, isBackButtonSelected,shouldCloseMenu]); // NO API CALL HERE

  // const loadData = async () => {
  //   const myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "application/json");
  //   myHeaders.append(
  //     "Authorization",
  //     `Bearer ${localStorage.getItem("JWTToken")}`
  //   );

  //   const raw = JSON.stringify({
  //     profile_id: 0,
  //     activity: 2,
  //     username: "Usernsme",
  //     profile: "profile",
  //     is_kid: 0,
  //   });

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };

  //   fetch(
  //     "https://node-api.pb-online.co.in/api/V1/updateUserProfile",
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => console.log(result))
  //     .catch((error) => console.error(error));
  // };

  // useEffect(() => {
  //   loadData();
  // }, []);

  // const addProfile = () => {
  //   if (profiles.length < 5) {
  //     setProfiles([
  //       ...profiles,
  //       {
  //         name: "New Profile",
  //         image: "https://via.placeholder.com/100",
  //         isKids: false,
  //       },
  //     ]);
  //   }
  // };

  const styles = {
    container: {
      backgroundImage: `url(${solidbackgroundimg})`,
      // textAlign: "center",
      color: "white",
      backgroundColor: "#000",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      // justifyContent: "center",
      // alignItems: "center",
    },
    profilesContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "30px",
      position: "relative",
      top: "20px",
    },
    profileCard: {
      backgroundColor: "#2c2c2c",
      borderRadius: "10px",
      // padding: "10px",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      // border: "7px solid white",
      width: "141px",
      height: "141px",
      border: "none",
      // margin: "0px",
      // padding: "0px",
      // boxSizing: "border-box",
    },
    profileName: {
      margin: "0px",
      padding: "0px",
      marginTop: "0px",
      fontFamily: "Anek Latin",
      fontWeight: 500,
      fontSize: "20px",
      position:"relative",
      top: "10px",
      // marginTop: "20px",
    },
    kidsBadge: {
      backgroundColor: "#ffcc00",
      borderRadius: "5px",
      padding: "2px 8px",
      marginLeft: "5px",
      marginTop: "10px",
      fontFamily: "Anek Latin",
      fontWeight: 500,
      color: "rgba(255, 255, 255, 1)",
      position:"absolute",
      bottom:"-12px",
    },
    addProfile: {
      backgroundColor: "#4c4c4c",
      justifyContent: "center",
    },
    addProfileIcon: {
      fontSize: "50px",
    },
    focusStyle: {
      border: "7px solid white",
      display: "block",
    },
    buttonStyle: {
      backgroundColor: "orange",
      border: "none",
      padding: "10px 20px",
      margin: "5px",
      borderRadius: "5px",
      cursor: "pointer",
      outline: "none",
    },
    deleteButtonStyle: {
      backgroundColor: "#ff4040",
    },
     selectedIcon: {
      position: "absolute",
      width: "40px",
      height: "40px",
      // right : "-3.4rem",
      // left: "4rem",
      // marginLeft: profiles.isKids === 0 ? "3rem" : "3.501rem",
      bottom: "1rem",
      boxSizing: "border-box",
      margin: "0",
      margin: "12px 12px",
      zIndex: 9999,
    }
  };

  


  const EditCont = {
    position: "absolute",
    background: "#0E1653",
    opacity: "0.6",
    width: "141px",
    height: "141px",
    border: "none",
    bottom: "0px",
    borderRadius: "10px",
    // padding: "23px",
    
  };

  if (screen === "MyProfile") {
    window.removeEventListener("keydown", EditProfileKeyHandler);
    return <MyProfile navigate={navigateToScreen} />;
  }
  else if (screen === "DeleteProfile") {
    window.removeEventListener("keydown", EditProfileKeyHandler);
    return <DeleteProfile navigate={navigateToScreen} />;
  }

  else if (screen === "AddProfile") {
    window.removeEventListener("keydown", EditProfileKeyHandler);
    return <AddProfile navigate={navigateToScreen} />;
  }

  return (
    <div style={styles.container}>
      <style>
        {`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
        `}
      </style>
      {/* <div style={{ position: "absolute" }}>
      <Wrapper
              as="button"
              style={{
                backgroundColor: "transparent",
                border: "none",
                marginLeft: "6rem",
                borderRadius: "1rem",
                aspectRatio: "1/1",
                cursor: "pointer",
                position: "relative",
                top: "4rem",
                zIndex:"1",
                // left: "6rem",
                outline: isBackButtonSelected ? "4px solid #EC008C" : "none",
              }}
              onMouseEnter={() => {
                setState((prev) => ({ ...prev, isBackButtonSelected: true }));
                setSelectedElementIndex(null);
              }}
              onClick={(e) => {
                handleBackButton();
                // handleBack();
                // handleClick(null, -2);
              }}
            >
              <img src={backIcon} width={50} height={50} />
            </Wrapper>
      </div> */}
      <div
        style={{
          alignContent: "center",
          alignItems: "centre",
          textAlign: "center",
          position: "relative",
          top: "15%",
          display:"flex",
          flexDirection:"column",
          height:"100vh",
          gap:"130px"
        }}
      >
        <h1
          style={{
            fontFamily: "Anek Latin",
            fontWeight: 500,
            fontSize: "32px",
            color: "rgba(255, 255, 255, 1)",
            position: "relative",
            // bottom: "15vh"
          }}
        >
          <Translate langKey={'Edit-Profile'}/>
        </h1>
        <div style={styles.profilesContainer}>
          {profiles.map((profile, index) => (
            <Wrapper
              style={
                selectedElementIndex === index
                  ? { ...styles.profileCard }
                  : styles.profileCard
              }
              key={index}
              tabIndex={0}
              ref={profileRefs.current[index]}
              id={`profile_${index}`}
              onClick={() => moveToUpdate(index)}
              // onClick={moveToUpdate}
              onMouseEnter={() => {
                 setState((prev) => ({ ...prev, isBackButtonSelected: false }));
                 setSelectedElementIndex(index);
              }}
            >
              <div style={EditCont}>
                <img
                  src={EditIcon}
                  style={{
                    width: "43px",
                    height: "44px",
                    position: "relative",
                    top: "45px",
                  }}
                />
              </div>
              <img
                src={profile.image}
                alt={profile.name}
                style={{
                  ...(selectedElementIndex === index
                    ? { ...styles.focusStyle }
                    : {}),
                  width: "151px",
                  height: "165px",
                  borderRadius: "10px",
                  marginTop: "-5px",
                }}
              />
                 {profile.isKids === 1 && (
                  <div style={styles.kidsBadge} >KIDS</div>
                )}
              <div style={styles.profileName}>
                {profile.name.length > 10 ? profile.name.slice(0, 10) + "..." : profile.name}
             
                  {confirmedSelection === index || (JSON.parse(localStorage.getItem("myProfile"))?.name === profile.name) && (
                  <img
                    src={selectedIcon} // Replace with the actual path to your checkmark icon
                    alt="Selected"
                    style={styles.selectedIcon}
                  />
                )}
              </div>
            </Wrapper>
          ))}
          {/* {profiles.length < 5 && (
          <div
            style={
              selectedElementIndex === profiles.length
                ? {
                    ...styles.profileCard,
                    ...styles.addProfile,
                    ...styles.focusStyle,
                  }
                : { ...styles.profileCard, ...styles.addProfile }
            }
            onClick={addProfile}
            ref={addProfileRef}
            tabIndex={0}
          >
            <div style={styles.addProfileIcon}>+</div>
            <div style={styles.profileName}>Add Profile</div>
          </div>
        )} */}
        </div>
      </div>
      <div style={{ position: "absolute" }}>
        <MenuScreen
          navigate={navigateToScreen}
          handleMenuselection={handleMenuselection}
          shouldCloseMenu={shouldCloseMenu}
          handleRightButton={handleRightButton}
          isLogedIn={isLogedIn}
          appNavigate={navigate}
          handleLogout={handleLogout}
          handleExit={handleExit}
        />
        {/* <LoaderScreen disply={loading ? "flex" : "none"} /> */}
      </div>
      <div
        style={{
          position: "absolute",
          // width: "100vw",
          // height: "100vh",
          // background: "yellow",
        }}
      >
        <ModalScreen
          shouldShowError={shouldShowModal}
          errTitle={errTitle}
          errDescription={errDescription}
          errIcon={errIcon}
          button={button}
          iconWdth={iconWdth}
          iconHeight={iconHeight}
          modalOKButtonHandler={modalOKButtonHandler}
          modalCANCELButtonHandler={modalCANCELButtonHandler}
        />
      </div>
      {/* <div
        style={{
          position: "absolute",
        }}
      >
        <AuthFailModal
          shouldShowError={shouldShowAuthModal}
          errTitle={errTitle}
          errDescription={errDescription}
          errIcon={errIcon}
          button={button}
          iconWdth={iconWdth}
          iconHeight={iconHeight}
          modalOKButtonHandler={modalOKButtonHandler}
          modalCANCELButtonHandler={modalCANCELButtonHandler}
        />
      </div> */}
    </div>
  );
};

export default EditProfile;